import cart from '@ppcp/cart';
import product from '@ppcp/product';
import {getSetting} from '@ppcp/utils';
import {ProductController} from '@ppcp/controllers';
import Context from '@ppcp/context';
import ApplePayGateway from '../gateways/ApplePayGateway';

const settings = getSetting('ppcp_applepay_data');
const productSettings = getSetting('productSettings');

const {disabled = false} = settings;

if (!disabled) {
    const gateway = new ApplePayGateway({
        id: 'ppcp_applepay',
        cart,
        settings
    });

    const controller = new ProductController(product, {
        id: 'ppcp_applepay',
        cart,
        context: new Context('product'),
        gateway,
        settings: {
            ...settings,
            product: productSettings
        }
    });

    controller.initialize();
}